import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import './Footer.css';

const Footer = () => {
  const publicUrl = process.env.PUBLIC_URL || '';
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="container footer-content">
        <div className="footer-section">
          <div className="footer-logo">
            <img src={`${publicUrl}/logomuseo.png`} alt="Museo Stibbert" className="footer-logo-image" />
          </div>
        </div>

        <div className="footer-section">
          <h4>{t('footer.contacts')}</h4>
          <p>{t('footer.address')}</p>
          <p>50134 Firenze</p>
          <p>Tel: 055 475520</p>
          <p>Email: bookshop@museostibbert.it</p>
        </div>

        <div className="footer-section">
          <h4>{t('footer.hours')}</h4>
          <p>{t('footer.hours_desc')}</p>
          <p>Ven - Dom: 10:00 - 18:00</p>
          <p>Giovedì: Chiuso</p>
        </div>

        <div className="footer-section">
          <h4>{t('footer.useful_links')}</h4>
          <p>
            <a href="https://www.museostibbert.it" target="_blank" rel="noopener noreferrer">
              {t('footer.museum_site')}
            </a>
          </p>
          <p>
            <a href="https://www.museostibbert.it" target="_blank" rel="noopener noreferrer">
              Informazioni Visite
            </a>
          </p>
          <p>
            <a href={`${publicUrl}/amministrazione`} target="_blank" rel="noopener noreferrer">
              Amministrazione
            </a>
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Museo Stibbert - Tutti i diritti riservati</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

